import type { FormValues } from "./types";

export const defaultFormValues = {
  "q[pref]": "",
  "q[city][]": [],
  "q[line][]": [],
  "q[station][]": [],
  "q[popular_area][]": [],
  "q[business_type][]": [],
  "q[employment][]": [],
  "q[salary_type]": "",
  "q[salary_min]": "",
  "q[salary_max]": "",
  "q[working_day][]": [],
  "q[holiday][]": [],
  "q[workstyle][]": [],
  "q[occupation][]": [],
  "q[facility_type][]": [],
  "q[customer_type][]": [],
  "q[feature][]": [],
  "q[experience][]": [],
  "q[welfare][]": [],
  "q[work_description][]": [],
  "q[user_credential][]": [],
  "q[salon_tour_flag]": false,
  "q[client_end_up_close_flag]": false,
  "q[keywords]": "",
} satisfies FormValues;
